<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import CardLayout from 'dashboard/components-next/CardLayout.vue';

const props = defineProps({
  customer: { type: Object, required: true },
});

const router = useRouter();
const { accountScopedRoute } = useAccount();

const name = computed(
  () => props.customer.name || props.customer.phone || `#${props.customer.id}`
);

const navigateTo = () => {
  router.push(
    accountScopedRoute('web_order_customer_profile', {
      customerId: props.customer.id,
    })
  );
};
</script>

<template>
  <button type="button" class="w-full text-left" @click="navigateTo">
    <CardLayout
      layout="row"
      class="[&>div]:items-start [&>div]:justify-start [&>div]:px-4 [&>div]:py-3 hover:bg-n-slate-2 dark:hover:bg-n-solid-3"
    >
      <span
        class="i-lucide-user mt-0.5 block size-4 shrink-0 text-n-slate-11"
        aria-hidden="true"
      />
      <div class="flex min-w-0 flex-1 flex-col gap-1.5">
        <h5 class="min-w-0 truncate py-1 text-sm font-medium text-n-slate-12">
          {{ name }}
        </h5>
        <div
          class="flex min-w-0 flex-wrap items-center gap-2 text-sm text-n-slate-11"
        >
          <span v-if="customer.phone" class="truncate">{{
            customer.phone
          }}</span>
          <span v-if="customer.email" class="truncate">{{
            customer.email
          }}</span>
        </div>
      </div>
    </CardLayout>
  </button>
</template>
